"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LISTINGS_SOURCE_PARAM = exports.COOKIE_REMOVAL_VALUE = exports.COOKIE_PARAM = void 0;
/**
 * URL Parameter & Param name for Yext conversion pixels
 *
 * @public
 */
exports.COOKIE_PARAM = '_yfpc';
exports.COOKIE_REMOVAL_VALUE = '__temp__';
exports.LISTINGS_SOURCE_PARAM = 'y_source';
//# sourceMappingURL=constants.js.map